import { avatarUrl } from '../lib/engine.js';

/**
 * Аватарка с запасным вариантом из буквы имени.
 *
 * Картинка может отсутствовать законно: человек её не ставил, либо ключ ещё
 * не запечатан для нас — так бывает первые секунды после появления общего
 * чата. В обоих случаях показываем букву, а не пустое место.
 */
export function Avatar({
  userId,
  name,
  size = 42,
}: {
  userId: string;
  name: string;
  size?: number;
}) {
  const url = avatarUrl(userId);

  return (
    <div
      class="avatar"
      style={`width:${size}px;height:${size}px;font-size:${Math.round(size * 0.4)}px`}
      aria-hidden="true"
    >
      {url ? <img src={url} alt="" /> : name.slice(0, 1).toUpperCase()}
    </div>
  );
}
